<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <template #label>
            {{label}} <span v-if="required" class="text-danger">*</span>
        </template>
        <b-form-radio-group
            v-model="inputVal"
            :state="state"
            stacked='stacked' 
            @change="$emit('change')">
            <b-form-radio v-for="option in options" :key="option.value" :value="option.value" :class="[option.class ? option.class : '']">{{option.text}}</b-form-radio>
        </b-form-radio-group>

    </b-form-group>
</template>

<script>
    import _ from "lodash";
    import list from '@/mixins/List';

    export default {
        mixins: [list],
        props: ['label', 'model', 'attribute', 'errors', 'errorOnly', 'required'],
        data: function () {
            return {
                autoLoad: false,
                service: '/category',
                defaultFilterFormModel: {
                    keyword: '',
                    size : 100,
                },
                changeTrigger: true,
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : [],
                state: null,
                errorTxt: '',
                options: [],
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
                // handler(val) {
                //     this.state = null;
                //     this.errorTxt = '';
                //     if (val[this.attribute] && val[this.attribute] !== null && val[this.attribute].length) {
                //         if (this.changeTrigger) {
                //             this.loadSelected();
                //         }
                //         this.changeTrigger = true;
                //     } else {
                //         this.inputVal = [];
                //     }
                // }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val && Object.keys(val).length) {
                    Object.keys(val).forEach(key => {
                        if (key === this.attribute) {
                            this.state = false;
                            this.errorTxt = val[key].join(";");
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            load() {
                let loadingDelay = _.delay(() => {
                    this.listLoading = true;
                }, 250);

                let filter = Object.assign({}, this.filterFormModel);
                if (this.filter) {
                    filter = Object.assign(this.filter, filter);
                }
                Object.keys(filter).forEach(key => {
                    if (typeof filter[key] === 'object' && filter[key]) {
                        filter[key] = filter[key].join(",");
                    }
                });
                this.$service.get(`${this.service}/index`, {
                    params: filter
                }).then(response => {
                    this.firstLoading = false;
                    this.apply(response.data);
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$swal({
                            text: error.response.data.message,
                            icon: 'error'
                        });
                    }
                }).finally(() => {
                    clearTimeout(loadingDelay);
                    this.listLoading = false;
                });
            },
            loadSelected() {
                if (this.model[this.attribute] && this.model[this.attribute].length) {
                    let ids = this.model[this.attribute].join(',');
                    if (ids) {
                        this.$service.get(`${this.service}/gets`, {
                            params: {ids: ids}
                        }).then(response => {
                            this.inputVal = response.data.map(item => item.id)[0];
                        });
                    }
                }
            },
            apply(response) {
                //list cat level 1
                let data = response.data.filter(i => i.parent_id === 0);
                for (let item of data) {
                    item.childs = response.data.filter(i => i.parent_id === item.id);
                    for (let child of item.childs) {
                        child.childs = response.data.filter(i => i.parent_id === child.id);
                    }
                }

                this.options = [{value: -1, text: "Trống"}];
                for (let item of data) {
                    this.options.push({value: item.id, text: item.name});
                    if (item.childs) {
                        for (let level2 of item.childs) {
                            this.options.push({value: level2.id, text: level2.name, class: "ml-4"});
                            for (let level3 of level2.childs) {
                                this.options.push({value: level3.id, text: level3.name, class: "ml-5"});
                            }
                        }
                    }
                }

                this.itemCount = response.dataCount;
                this.params = response.params;
                this.firstItemOfPage = this.itemCount > 0 ? (this.filterFormModel.page - 1) * this.filterFormModel.size + 1 : 0;
                this.lastItemOfPage = ((this.filterFormModel.page - 1) * this.filterFormModel.size) + this.items.length;
                this.isEmpty = this.itemCount <= 0;
            },
        },
        mounted() {
            this.inputVal = [];
            this.loadSelected();
            this.load();
        }
    }
</script>
